import api from "./api";

const profileService = {
  getMe: async () => {
    const res = await api.get("/api/user/me");
    return res.data?.data?.user || null;
  },
  updateMe: async (payload) => {
    const res = await api.put("/api/user/me", payload);
    return res.data?.data?.user || null;
  },
  uploadAvatar: async (file) => {
    const form = new FormData();
    form.append("image", file);
    const res = await api.post("/api/user/me/image", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data?.data?.user || null;
  },
};

export default profileService;
